module.exports = __webpack_public_path__ + "img/pro_seven_6.185a79eb.jpg";